import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const LinkElement = styled.div`
  display: flex;
  margin: ${props => props.theme.space.xs};
  padding: ${props => props.theme.space.xs};
  color: ${props => props.theme.colors.sidebar.foreground};
  text-decoration: none;
  border-radius: ${props => props.theme.borderRadii.md};
  transition: background 0.2s;
  ${props =>
    props.$isTopLevel &&
    `font-weight: ${props.theme.fontWeights.semibold};
     font-size: ${props.theme.fontSizes.lg};`}
  ${props => props.$isNested && `margin-right: 0;`}

  &:hover,
  &:active {
    color: ${props => props.theme.colors.sidebar.foreground};
    text-decoration: none;
    background-color: ${props =>
      props.theme.colors.sidebar.linkBackgroundHover};
  }

  &:focus {
    color: ${props => props.theme.colors.sidebar.foreground};
    text-decoration: none;
    box-shadow: ${props => props.theme.focusBoxShadow};
  }
`

const SidebarLink = props => {
  const { external, isNested, isTopLevel, tabIndex, to, children } = props
  const tag = external ? "a" : Link
  const target = external ? "_blank" : null
  return (
    <LinkElement
      as={tag}
      target={target}
      $isNested={isNested}
      $isTopLevel={isTopLevel}
      tabIndex={tabIndex}
      href={to}
      to={to}
    >
      {children}
    </LinkElement>
  )
}

SidebarLink.propTypes = {
  external: PropTypes.bool,
  isNested: PropTypes.bool.isRequired,
  isTopLevel: PropTypes.bool.isRequired,
  tabIndex: PropTypes.number.isRequired,
  to: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
}

SidebarLink.defaultProps = {
  external: false
}

export default SidebarLink
